import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsResentQuoteButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleResentButton() {
    setTimeout(() => {
      const jobId = this.state?.data?.id;
      const unitData = this.state?.data?.unit?.units_data ? JSON.parse(this.state.data.unit.units_data) : null;
      const hasUnits = unitData && unitData.units && unitData.units.length > 0;

      // 🚫 STOP request if no units
      if (!hasUnits) {
        alert("No unit data found. Mail not sent.");
        return; // <-- stops mail request instantly
      }

      $.ajax({
        url: '/send-quote-email',
        type: 'POST',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          jobId: jobId,
        },
        success: (response) => {
          alert(response.message);
        },
        error: () => {
          alert("Failed to send quote email!");
        }
      });
    }, 100);
  }

  render() {
    return (
      <p>Send Quote<br />
        <button
          type="button"
          className="btn btn-lg btn-dark job-row-highlighter-option-grey"
          title="send mail for job"
          onClick={(e) => {
            e.preventDefault();
            this.toggleResentButton();
          }}
        >
          Resent Quote
        </button>
      </p>
    )
  }
}